/* eslint-disable no-unused-vars */
import { Palette } from 'config';
import styled, { css } from 'styled-components';

export const OuterContainer = styled.div`
  width: 100%;
  padding: 54px 24px 12px 24px;
  background-color: ${Palette.White._000};
`;

// 1150px - hardcoded width to stop scaling when the page doesn't fitt the screen
export const Container = styled.div`
  position: relative;
  width: 100%;
  display: flex;
  flex-wrap: nowrap;
  min-width: 1150px;
`;

export const DaysWrap = styled.div`
  width: 100%;
  height: 100%;
  display: flex;
  flex-wrap: nowrap;
`;

export const ChartWrap = styled.div`
  position: absolute;
  width: 100%;
  z-index: 0;
  box-shadow: 0px 1px 0px 0px ${Palette.PrimaryGray._200},
    0px -1px 0px 0px ${Palette.PrimaryGray._200};

  &::before {
    content: ' ';
    position: absolute;
    top: 50%;
    left: 0;
    right: 0;
    transform: translateY(-50%);
    height: 1px;
    background-color: ${Palette.PrimaryGray._200};
    z-index: -10;
  }
`;

export const ScaleNumber = styled.div`
  display: inline-block;
  width: fit-content;
  padding: 4px;
  font-weight: 400;
  font-size: 12px;
  user-select: none;
  color: ${Palette.PrimaryGray._400};
  background-color: ${Palette.White._000};
`;

export const ScaleLeft = styled.div`
  position: absolute;
  top: -12px;
  bottom: -12px;
  left: -18px;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
`;

export const ScaleRight = styled.div`
  position: absolute;
  top: -12px;
  bottom: -12px;
  right: -18px;
  text-align: right;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  align-items: flex-end;
`;
